import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import swal from 'sweetalert2';
import { BillingService } from '../../../services/billing.service';
import { getParamFromAncestorRoute, getQueryParamFromAncestorRoute } from '../../../utilities/route.utilities';


@Component({
    selector: 'payg-payment-transmission-performance-grid-item',
    templateUrl: './payg-payment-transmission-performance-grid-item.component.html',
})
export class PaygPaymentTransnissonPerformanceGridItemComponent implements OnInit, OnDestroy {

    subscriptions: any[] = [];
    timePeriod: number = 1;
    clientId: number;
    siteId: number;
    agedDebt: any[] = [];
    hasData: boolean = false;
    hasLoading: boolean = true;
    constructor(
        private route: ActivatedRoute,
        private router: Router) {
        this.subscriptions.push(router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.ngOnInit();
            }
        }));
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    onInfoClick() {
        swal({
            title: 'Payment transmission performance',
            html: '<p style="text-align: left;">This chart shows the total quantity of payments within time-frames taken for the payments to reach the PAYG device. </p>\
                <p style="text-align: left;"> If payments are taking longer to transmit than expected, speak to us.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }
}
